/**
 * Loại chỉ tiêu chờ phân bổ
 * dvhung2 26.11.2024
 */
export default {
    ExpenseInvest: 1,
    ExpenseProject: 2,
    ExpenseRegular: 3,
  };